// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoContainer_wrapper__1Cj4e","videous_container":"VideoContainer_videous_container__xMlZL","empty_result":"VideoContainer_empty_result__KiAF6"};